module.exports = __webpack_public_path__ + "static/oops-course-32fb24a2165c9791f8f9890fa7522243.svg";